import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from "pinia";
import { computed, ref, watch } from "vue";
import { useObjectStoreStore } from "@/stores/objectStoreStore";
import FilterObjectStoreLink from "./FilterObjectStoreLink.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FilterMenuObjectStore',
    props: {
        name: null,
        filter: null,
        filters: null
    },
    emits: ["change"],
    setup(__props, { emit }) {
        const props = __props;
        const propValue = computed(() => props.filters[props.name]);
        const localValue = ref(propValue.value);
        watch(() => localValue.value, (newFilter) => {
            emit("change", props.name, newFilter);
        });
        watch(() => propValue.value, (newFilter) => {
            localValue.value = newFilter;
        });
        const store = useObjectStoreStore();
        const { selectableObjectStores } = storeToRefs(store);
        const hasObjectStores = computed(() => {
            return selectableObjectStores.value && selectableObjectStores.value.length > 0;
        });
        function onChange(value) {
            localValue.value = (value || undefined);
        }
        return { __sfc: true, props, emit, propValue, localValue, store, selectableObjectStores, hasObjectStores, onChange, FilterObjectStoreLink };
    }
});
